<template>
    <rkm-area
        title="Informações obstétricas"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col cols="2">
                <rkm-form-input
                    :validations="validations.gestasPrevias"
                    label="Gestas prévias"
                    number
                    v-model="data.model.informacoesObstetricas.gestasPrevias"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-input
                    :validations="validations.abortos"
                    label="Abortos"
                    number
                    v-model="data.model.informacoesObstetricas.abortos"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-checkbox
                    :label="false"
                    :value="true"
                    v-model="data.model.informacoesObstetricas.desfechoGestacaoAconteceuMenosUmAno"
                >
                    Desfecho da última gestação aconteceu há menos de um ano
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="2">
                <rkm-form-input
                    :validations="validations.partosRealizados"
                    label="Partos realizados"
                    number
                    v-model="data.model.informacoesObstetricas.partosRealizados"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-input
                    :validations="validations.partosVaginais"
                    label="Vaginais"
                    number
                    v-model="data.model.informacoesObstetricas.partosVaginais"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-input
                    :validations="validations.partosCesareas"
                    label="Cesáreas"
                    number
                    v-model="data.model.informacoesObstetricas.partosCesareas"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-input
                    :validations="validations.partosDomiciliares"
                    label="Partos domiciliares"
                    number
                    v-model="data.model.informacoesObstetricas.partosDomiciliares"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-area
                    title="Nascidos"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-input
                                :validations="validations.nascidosVivos"
                                label="Vivos"
                                number
                                v-model="data.model.informacoesObstetricas.nascidosVivos"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-input
                                :validations="validations.nascidosMortos"
                                label="Mortos"
                                number
                                v-model="data.model.informacoesObstetricas.nascidosMortos"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-area
                    title="Recém-nascidos com"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-input
                                :validations="validations.recemNascidosComMenos2500Gramas"
                                label="Menos de 2500g"
                                number
                                v-model="data.model.informacoesObstetricas.recemNascidosComMenos2500Gramas"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-input
                                :validations="validations.recemNascidosComMais4500Gramas"
                                label="Mais de 4500g"
                                number
                                v-model="data.model.informacoesObstetricas.recemNascidosComMais4500Gramas"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    title="Nascidos vivos"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="2">
                            <rkm-form-input
                                :validations="validations.nascidosVivosVivem"
                                label="Vivem"
                                number
                                v-model="data.model.informacoesObstetricas.nascidosVivosVivem"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :validations="validations.nascidosVivosMortosPrimeiraSemana"
                                label="Mortos na 1ª semana"
                                number
                                v-model="data.model.informacoesObstetricas.nascidosVivosMortosPrimeiraSemana"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :validations="validations.nascidosVivosMortosDepoisPrimeiraSemana"
                                label="Mortos depois da 1ª semana"
                                number
                                v-model="data.model.informacoesObstetricas.nascidosVivosMortosDepoisPrimeiraSemana"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
export default {
    computed: {
        validations() {
            return {
                gestasPrevias: {max: 2},
                abortos: {max: 2},
                partosRealizados: {max: 2},
                partosVaginais: {max: 2},
                partosCesareas: {max: 2},
                partosDomiciliares: {max: 2},
                nascidosVivos: {max: 2},
                nascidosMortos: {max: 2},
                recemNascidosComMenos2500Gramas: {max: 2},
                recemNascidosComMais4500Gramas: {max: 2},
                nascidosVivosVivem: {max: 2},
                nascidosVivosMortosPrimeiraSemana: {max: 2},
                nascidosVivosMortosDepoisPrimeiraSemana: {max: 2},
            }
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>